<template>
    <div class="home">
        <iframe name="GIS" frameborder="0" width="100%" height="100%" ref="iframeDom"
            src="http://47.99.177.252:5505/3D/public/level/kj_new.html">
        </iframe>
        
        <!-- <MenuButton :content="'园区总览'" @click="$router.push({path: '/'})"></MenuButton> -->
    </div>
</template>

<script>
    import MenuButton from "../components/MenuButton";
    export default {
        name: "Site",
        components: {
            MenuButton,
        }
    };
</script>


<style scoped>
    .home {
        margin: 0;
        padding: 0;
        width: 100vw;
        height: 100vh;
        overflow: hidden;
    }

    iframe{
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
    }
</style>